"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectAssetSummaryItem = void 0;
const AssetRegulation_1 = require("./AssetRegulation");
// TODO: 対応するgeneratorがないので作る
class ProjectAssetSummary {
    constructor({ totalUploadedAmount, assetSummaryItems, }) {
        this.toJSON = () => ({
            totalUploadedAmount: this.totalUploadedAmount,
            assetSummaryItems: this.assetSummaryItems.map(item => item.toJSON()),
        });
        this.totalUploadedAmount = totalUploadedAmount;
        this.assetSummaryItems = assetSummaryItems;
    }
    static fromJSON(json) {
        const { totalUploadedAmount, assetSummaryItems } = Object.assign({}, json);
        if (typeof totalUploadedAmount !== 'number')
            throw new Error('.totalUploadedAmount must be a number');
        if (!Array.isArray(assetSummaryItems))
            throw new Error('.assetSummaryItems must be an array');
        return new ProjectAssetSummary({
            totalUploadedAmount,
            assetSummaryItems: assetSummaryItems.map(item => ProjectAssetSummaryItem.fromJSON(item)),
        });
    }
}
class ProjectAssetSummaryItem {
    constructor({ uploadedAmount, assetRegulation }) {
        this.toJSON = () => ({
            uploadedAmount: this.uploadedAmount,
            assetRegulation: this.assetRegulation.toJSON(),
        });
        this.uploadedAmount = uploadedAmount;
        this.assetRegulation = assetRegulation;
    }
    static fromJSON(json) {
        const { uploadedAmount, assetRegulation } = Object.assign({}, json);
        if (typeof uploadedAmount !== 'number')
            throw new Error('.uploadedAmount must be a number');
        return new ProjectAssetSummaryItem({
            uploadedAmount,
            assetRegulation: AssetRegulation_1.AssetRegulationItem.fromJSON(assetRegulation),
        });
    }
}
exports.ProjectAssetSummaryItem = ProjectAssetSummaryItem;
exports.default = ProjectAssetSummary;
